import * as React from 'react';
import * as mrCap from './mrCapTypes';
import { views, ViewSteps, ViewNav } from './view/steps';
import { ViewProp } from './view';
import { create, update } from './api/booking';
import { getCampaignId, getCampaignBookingTypes, className } from './util';
import * as gtm from './gtm';
import { SetShopCookie } from './cookies';

interface BookingFormProps extends mrCap.BookingFormSettings {
}

interface BookingFormState {
  viewIndex: number;
  regNr?: string;
  selectedProducts: mrCap.Product[];
  selectedShop: mrCap.Shop | null;
  selectedMabi?: string | null;
  booking: mrCap.BookingRequest;
  shipping: number;
  ruleWindow: boolean;
  selectedDate: Date | null;
  bookingId: string;
  financing: boolean;
  financingTypes: mrCap.BookingType[];
  carDetails?: mrCap.VehicleInfo;
  onSiteOk: boolean;
  campaign?: mrCap.CampaignResponse;
}

export class BookingForm extends React.Component<BookingFormProps, BookingFormState> {

  constructor(props: BookingFormProps) {
    super(props);

    this.state = {
      viewIndex: 0,
      regNr: '',
      selectedProducts: [],
      selectedShop: null,
      bookingId: '',
      booking: {
        name: '',
        address: '',
        city: '',
        zipCode: '',
        comment: '',
        phone: '',
        email: '',
        bookingType: mrCap.BookingType.ecsterPay,
        regNr: '',
        stationId: 0,
        bookingDate: new Date(),
        newsletter: false,
        articles: [],
        campaingId: getCampaignId(),
        mabiVehicle: '',
        driversLicenseNumber: ''
      },
      shipping: 0,
      ruleWindow: false,
      selectedDate: null,
      financing: false,
      financingTypes: [mrCap.BookingType.onLocation],
      onSiteOk: false
    };
  }

  toggleProduct = (product: mrCap.Product) => {
    let selectedProducts = this.state.selectedProducts.slice();

    const index = selectedProducts.findIndex(p => p.articleNr === product.articleNr);
    const gtmProduct = gtm.convertProduct(product, this.state.campaign?.code);

    if (index >= 0) {
      selectedProducts.splice(index, 1);
      gtm.removeProductFromCart(gtmProduct);
    } else {
      selectedProducts = [...selectedProducts, product];
      gtm.addProductToCart(gtmProduct);
    }

    this.setState({
      selectedProducts,
      booking: {
        ...this.state.booking,
        articles: selectedProducts.map(p => ({artNr: p.articleNr, noi: p.noi}))
      }
    });
  };

  updateSelectedProducts = (products: mrCap.Product[]) => {
    let selectedProducts = this.state.selectedProducts;
    this.setState({
      selectedProducts: selectedProducts
        .map(product => products
          .find(newProduct => newProduct.articleNr === product.articleNr) || product)
    });
  };

  updateProduct = (artNr: string, noi: number) => {
    let selectedProducts = this.state.selectedProducts;

    if (selectedProducts) {

      let product = selectedProducts.find(p => p.articleNr === artNr);

      if (product) {
        product.noi = noi;

        this.setState({
          selectedProducts,
          booking: {
            ...this.state.booking,
            articles: selectedProducts.map(p => ({artNr: p.articleNr, noi: p.noi}))
          }
        });
      }
    }
  };

  componentDidMount() {
    this.createBooking();
  }

  async createBooking() {
    const res = await create();
    this.setState({ bookingId: res.orderId });
  }

  async updateBooking() {
    const booking: mrCap.BookingRequest = {
      ...this.state.booking,
      regNr: this.state.regNr ?? '',
      stationId: this.state.selectedShop?.id ?? 0,
      comment: this.state.booking.comment ?? '',
      bookingDate: this.state.selectedDate ?? new Date(),
      mabiVehicle: this.state.selectedMabi ?? '',
      driversLicenseNumber: this.state.booking.driversLicenseNumber ?? ''
    };

    try {
      const response = await update(this.state.bookingId, booking);
      this.setState({ shipping: response.shipping });
    } catch (ex) {
      console.error(ex);
    }

    this.setState({ booking });
  }

  render() {
    const { viewIndex } = this.state;
    const view = views[viewIndex];

    const viewProps: ViewProp = {
      regNr: this.state.regNr,
      carDetails: this.state.carDetails,
      selectedProducts: this.state.selectedProducts,
      selectedShop: this.state.selectedShop,
      selectedDate: this.state.selectedDate,
      selectedMabi: this.state.selectedMabi,
      texts: this.props.text,
      ecster: this.props.ecsterConfig,
      bookingId: this.state.bookingId,
      financing: false, //this.state.financing,
      financingTypes: this.state.financingTypes,
      booking: this.state.booking,
      shipping: this.state.shipping,
      onSiteOk: this.state.onSiteOk,
      campaign: this.state.campaign,
      mabi: this.props.mabi,
      weightThreshold: this.props.weightThreshold,
      initialFilterArticleGroup: this.props.initialFilterArticleGroup,

      toggleProduct: this.toggleProduct,
      updateProduct: this.updateProduct,
      setRegNr: regNr => this.setState({ regNr }),
      setShop: selectedShop => this.setState({ selectedShop }, () => SetShopCookie(selectedShop.id)),
      setDate: selectedDate => this.setState({ selectedDate }),
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      moveNext,
      togglePayment: () => {}, //this.setState({ financing: !this.state.financing }),
      setCarDetails: carDetails => this.setState({ carDetails }),
      setBookingDetails: booking => this.setState({ booking }),
      setOk: onSiteOk => this.setState({ onSiteOk }),
      setCampaign: campaign => {
        let types = getCampaignBookingTypes(campaign.paymentTypes);

        if (!types.length) {
          types = this.state.financingTypes;
        }

        this.setState({
          campaign,
          booking: {
            ...this.state.booking,
            campaingId: campaign.code
          },
          financingTypes: types,
          financing: false //types.some(type => type === mrCap.BookingType.ecsterPay)
        });
      },

      setMabi: selectedMabi => this.setState({ selectedMabi }),
      updateSelectedProducts: this.updateSelectedProducts
    };

    const resetRuleWindow = () => {
      setTimeout(() => {
        this.setState({ ruleWindow: false });
      }, 2000);
    };

    function moveNext(force = false) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      moveView(viewIndex + 1, force);
    };

    const move = view.canMoveNext(viewProps);

    const moveView = async (index: number, force = false) => {
      if (index > viewIndex) {
        if (!force && !move.ok) {
          this.setState({ ruleWindow: true });
          resetRuleWindow();
          return;
        } else {
          window.scroll(0, 0);
        }
      }

      await this.updateBooking();
      this.setState({ viewIndex: index });
    };

    const onlyProducts = this.state.selectedProducts.every(item => item.type === mrCap.ArticleType.product);

    return (
      <div className='booking-form'>

        <a className='top-logo' href='https://mrcap.com'>
          <img src='https://cdn.empori.se/customer_logotypes/mrcap-logotype-black.png'/>
        </a>

        <ViewSteps viewIndex={viewIndex} />

        {React.createElement(view.component, viewProps)}

        <div className={className('move-error-window', { visible: this.state.ruleWindow })}>
          <span>
            <i className='fas fa-exclamation-triangle'></i>
            <span dangerouslySetInnerHTML={{__html: move.error!}}></span>
          </span>
        </div>

        <ViewNav
          view={view}
          viewIndex={viewIndex}
          change={moveView}
          financing={this.state.financing}
          onlyProducts={onlyProducts}
          setFinancing={(value) => this.setState({
            financing: value
          })} />

        <iframe
          src="https://widget.reco.se/v2/partner/mrcap?mode=HORIZONTAL_QUOTE"
          width="100%"
          height="225"
          scrolling="no"
          style={{border: 0, display: 'block'}}
          data-reactroot=""></iframe>
      </div>
    );
  }
}